/** @jsx jsx */

import { jsx } from '@emotion/core';

export const Certificate_2_SVG = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 2084 1471.6"
      xmlSpace="preserve"
    >
      <g id="Change_colour">
        <path
          style={{
            opacity: 0.97,
            fill: '#00CBC3',
          }}
          d="M78.4,76.6v1316.8h1927V76.6H78.4z"
        />
      </g>
      <g id="Foreground">
        <g>
          <path
            style={{
              opacity: 0.97,
              fill: '#FFFFFF',
            }}
            d="M407.9-0.9v549.4v159.9V1472h1676.6l0.9-1472.9H407.9z M1879.1,1261.7l-31.7,45.4    l-38.3-77.4c-3.1,0.2-6.2,0.4-9.3,0.4c-3.1,0-6.2-0.2-9.3-0.4l-38.3,77.4l-31.7-45.4l-55.4,2.4l3.4-6.8l35.9-72.5    c-17.3-21.2-27.7-48.3-27.7-77.9c0-68,55.2-123.2,123.2-123.2c68,0,123.2,55.2,123.2,123.2c0,29.5-10.4,56.6-27.7,77.9l35.9,72.5    l3.4,6.8L1879.1,1261.7z"
          />
        </g>
        <g>
          <path
            style={{
              fill: '#241F20',
            }}
            d="M482.1,566.3c6-10.6,14.3-18.8,24.7-24.7c10.5-5.9,22.2-8.9,35.2-8.9c15.2,0,28.5,3.9,39.9,11.7    c11.4,7.8,19.4,18.6,24,32.3h-31.4c-3.1-6.5-7.5-11.4-13.2-14.6c-5.7-3.2-12.2-4.9-19.6-4.9c-7.9,0-15,1.9-21.1,5.6    c-6.2,3.7-11,8.9-14.4,15.7c-3.4,6.8-5.2,14.7-5.2,23.8c0,9,1.7,16.9,5.2,23.7c3.4,6.8,8.2,12.1,14.4,15.8    c6.2,3.7,13.2,5.6,21.1,5.6c7.4,0,13.9-1.7,19.6-5c5.7-3.3,10-8.2,13.2-14.7h31.4c-4.5,13.9-12.5,24.7-23.9,32.4    c-11.4,7.7-24.7,11.6-40,11.6c-13,0-24.7-3-35.2-8.9c-10.5-5.9-18.7-14.1-24.7-24.7c-6-10.5-9.1-22.5-9.1-35.9    C473,588.9,476,576.9,482.1,566.3z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M728.8,624.7h-78.9c0.6,7.8,3.4,13.9,8.2,18.3c4.8,4.4,10.7,6.6,17.7,6.6    c10.1,0,17.3-4.4,21.6-13.1h29.4c-3.1,10.4-9.1,18.9-17.9,25.6c-8.8,6.7-19.7,10-32.5,10c-10.4,0-19.7-2.3-28-6.9    c-8.3-4.6-14.7-11.1-19.3-19.6c-4.6-8.4-6.9-18.2-6.9-29.2c0-11.2,2.3-21,6.8-29.4c4.5-8.4,10.9-14.9,19.1-19.5    c8.2-4.5,17.6-6.8,28.3-6.8c10.3,0,19.5,2.2,27.6,6.6c8.1,4.4,14.4,10.7,18.9,18.8c4.5,8.1,6.7,17.4,6.7,28    C729.6,618,729.4,621.5,728.8,624.7z M701.4,606.3c-0.1-7-2.7-12.6-7.6-16.9c-4.9-4.2-11-6.3-18.1-6.3c-6.8,0-12.4,2-17.1,6.1    c-4.6,4.1-7.4,9.8-8.5,17.1H701.4z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M790.5,565.8c5.7-3.2,12.1-4.9,19.4-4.9v28.6h-7.2c-8.6,0-15,2-19.4,6c-4.4,4-6.5,11-6.5,21v53.8    h-27.3v-108h27.3v16.8C780.3,573.5,784.9,569.1,790.5,565.8z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M860,584.9v52.2c0,3.6,0.9,6.3,2.6,7.9c1.8,1.6,4.7,2.4,8.9,2.4h12.7v23H867    c-23,0-34.5-11.2-34.5-33.5v-52h-12.9v-22.4h12.9v-26.7H860v26.7h24.2v22.4H860z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M905.7,545c-3.2-3.1-4.8-6.9-4.8-11.4c0-4.5,1.6-8.3,4.8-11.4c3.2-3.1,7.2-4.6,12-4.6    c4.8,0,8.8,1.5,12,4.6c3.2,3.1,4.8,6.9,4.8,11.4c0,4.5-1.6,8.3-4.8,11.4c-3.2,3.1-7.2,4.6-12,4.6    C912.9,549.6,908.9,548.1,905.7,545z M931.1,562.5v108h-27.3v-108H931.1z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1007.5,584.9h-18.9v85.5h-27.7v-85.5h-12.3v-22.4h12.3V557c0-13.3,3.8-23,11.3-29.2    c7.5-6.2,18.9-9.2,34.1-8.8v23c-6.6-0.1-11.2,1-13.8,3.3c-2.6,2.3-3.9,6.6-3.9,12.7v4.5h18.9V584.9z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1027.1,545c-3.2-3.1-4.8-6.9-4.8-11.4c0-4.5,1.6-8.3,4.8-11.4c3.2-3.1,7.2-4.6,12-4.6    c4.8,0,8.8,1.5,12,4.6c3.2,3.1,4.8,6.9,4.8,11.4c0,4.5-1.6,8.3-4.8,11.4c-3.2,3.1-7.2,4.6-12,4.6    C1034.3,549.6,1030.3,548.1,1027.1,545z M1052.5,562.5v108h-27.3v-108H1052.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1079.2,587.1c4.5-8.4,10.8-14.9,18.9-19.5c8.1-4.6,17.3-6.9,27.7-6.9c13.4,0,24.5,3.3,33.2,10    c8.8,6.7,14.6,16.1,17.6,28.2h-29.4c-1.6-4.7-4.2-8.3-7.9-11c-3.7-2.7-8.3-4-13.7-4c-7.8,0-14,2.8-18.5,8.5    c-4.5,5.7-6.8,13.7-6.8,24.1c0,10.3,2.3,18.2,6.8,23.9c4.5,5.7,10.7,8.5,18.5,8.5c11,0,18.3-4.9,21.6-14.8h29.4    c-3,11.7-8.9,21-17.7,27.9c-8.8,6.9-19.9,10.3-33.1,10.3c-10.4,0-19.6-2.3-27.7-6.9c-8.1-4.6-14.4-11.1-18.9-19.5    c-4.5-8.4-6.8-18.2-6.8-29.3C1072.4,605.3,1074.7,595.5,1079.2,587.1z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1196.2,587c4.3-8.4,10.3-14.9,17.7-19.5c7.5-4.5,15.8-6.8,25-6.8c8.1,0,15.1,1.6,21.1,4.9    c6,3.2,10.9,7.3,14.5,12.3v-15.4h27.5v108h-27.5v-15.8c-3.5,5.1-8.3,9.3-14.5,12.6c-6.2,3.3-13.3,5-21.3,5c-9.1,0-17.4-2.3-24.8-7    c-7.5-4.7-13.4-11.3-17.7-19.8c-4.4-8.5-6.5-18.3-6.5-29.3C1189.7,605.2,1191.9,595.5,1196.2,587z M1270.8,599.4    c-2.6-4.7-6.1-8.4-10.5-10.9c-4.4-2.5-9.2-3.8-14.2-3.8c-5.1,0-9.7,1.2-14,3.7c-4.3,2.5-7.8,6.1-10.4,10.8c-2.7,4.7-4,10.4-4,16.9    c0,6.5,1.3,12.2,4,17.1c2.7,4.9,6.2,8.6,10.5,11.2c4.3,2.6,9,3.9,13.9,3.9c5.1,0,9.8-1.3,14.2-3.8c4.4-2.5,7.9-6.2,10.5-10.9    c2.6-4.7,3.9-10.4,3.9-17.1C1274.7,609.8,1273.4,604.2,1270.8,599.4z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1360.6,584.9v52.2c0,3.6,0.9,6.3,2.6,7.9c1.8,1.6,4.7,2.4,8.9,2.4h12.7v23h-17.1    c-23,0-34.5-11.2-34.5-33.5v-52h-12.9v-22.4h12.9v-26.7h27.5v26.7h24.2v22.4H1360.6z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1504,624.7h-78.9c0.6,7.8,3.4,13.9,8.2,18.3c4.8,4.4,10.7,6.6,17.7,6.6c10.1,0,17.3-4.4,21.6-13.1    h29.4c-3.1,10.4-9.1,18.9-17.9,25.6c-8.8,6.7-19.7,10-32.5,10c-10.4,0-19.7-2.3-28-6.9c-8.3-4.6-14.7-11.1-19.3-19.6    c-4.6-8.4-6.9-18.2-6.9-29.2c0-11.2,2.3-21,6.8-29.4c4.5-8.4,10.9-14.9,19.1-19.5c8.2-4.5,17.6-6.8,28.3-6.8    c10.3,0,19.5,2.2,27.6,6.6c8.1,4.4,14.4,10.7,18.9,18.8c4.5,8.1,6.7,17.4,6.7,28C1504.8,618,1504.5,621.5,1504,624.7z     M1476.5,606.3c-0.1-7-2.7-12.6-7.6-16.9c-4.9-4.2-11-6.3-18.1-6.3c-6.8,0-12.4,2-17.1,6.1c-4.6,4.1-7.4,9.8-8.5,17.1H1476.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M507.7,874.7c-10.7-6-19.1-14.3-25.3-24.8c-6.2-10.6-9.4-22.6-9.4-36c0-13.3,3.1-25.2,9.4-35.8    c6.2-10.6,14.7-18.9,25.3-24.8c10.7-6,22.3-9,35.1-9c12.9,0,24.6,3,35.2,9c10.6,6,19,14.3,25.1,24.8c6.2,10.6,9.3,22.5,9.3,35.8    c0,13.4-3.1,25.4-9.3,36c-6.2,10.6-14.6,18.9-25.2,24.8c-10.7,6-22.3,9-35.1,9S518.3,880.6,507.7,874.7z M564.4,853.7    c6.2-3.7,11.1-9,14.6-15.9c3.5-6.9,5.3-14.9,5.3-24c0-9.1-1.8-17.1-5.3-23.9c-3.5-6.8-8.4-12-14.6-15.7    c-6.2-3.6-13.4-5.5-21.6-5.5c-8.2,0-15.4,1.8-21.7,5.5c-6.3,3.6-11.2,8.9-14.7,15.7c-3.5,6.8-5.3,14.8-5.3,23.9    c0,9.1,1.8,17.1,5.3,24c3.5,6.9,8.4,12.2,14.7,15.9c6.3,3.7,13.5,5.6,21.7,5.6C550.9,859.3,558.2,857.4,564.4,853.7z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M682.1,796.7h-18.9v85.5h-27.7v-85.5h-12.3v-22.4h12.3v-5.5c0-13.3,3.8-23,11.3-29.2    c7.5-6.2,18.9-9.2,34.1-8.8v23c-6.6-0.1-11.2,1-13.8,3.3c-2.6,2.3-3.9,6.6-3.9,12.7v4.5h18.9V796.7z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M748.6,778.1c6-10.6,14.3-18.8,24.7-24.7c10.5-5.9,22.2-8.9,35.2-8.9c15.2,0,28.5,3.9,39.9,11.7    c11.4,7.8,19.4,18.6,24,32.3h-31.4c-3.1-6.5-7.5-11.4-13.2-14.6c-5.7-3.2-12.2-4.9-19.6-4.9c-7.9,0-15,1.9-21.1,5.6    c-6.2,3.7-11,8.9-14.4,15.7c-3.4,6.8-5.2,14.7-5.2,23.8c0,9,1.7,16.9,5.2,23.7c3.4,6.8,8.2,12.1,14.4,15.8    c6.2,3.7,13.2,5.6,21.1,5.6c7.4,0,13.9-1.7,19.6-5c5.7-3.3,10-8.2,13.2-14.7h31.4c-4.5,13.9-12.5,24.7-23.9,32.4    c-11.4,7.7-24.7,11.6-40,11.6c-13,0-24.7-3-35.2-8.9c-10.5-5.9-18.7-14.1-24.7-24.7c-6-10.5-9.1-22.5-9.1-35.9    C739.6,800.7,742.6,788.7,748.6,778.1z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M915.7,877.1c-8.3-4.6-14.8-11.1-19.6-19.6c-4.7-8.4-7.1-18.2-7.1-29.2c0-11,2.4-20.8,7.3-29.2    c4.9-8.4,11.5-15,20-19.6c8.4-4.6,17.9-6.9,28.3-6.9c10.4,0,19.8,2.3,28.3,6.9c8.4,4.6,15.1,11.1,20,19.6    c4.9,8.4,7.3,18.2,7.3,29.2c0,11-2.5,20.8-7.5,29.2c-5,8.4-11.8,15-20.3,19.6c-8.5,4.6-18,6.9-28.5,6.9    C933.4,884,924,881.7,915.7,877.1z M957.7,856.6c4.4-2.4,7.8-6,10.4-10.8c2.6-4.8,3.9-10.7,3.9-17.5c0-10.3-2.7-18.2-8.1-23.7    c-5.4-5.5-12-8.3-19.8-8.3c-7.8,0-14.3,2.8-19.6,8.3c-5.3,5.5-7.9,13.4-7.9,23.7c0,10.3,2.6,18.2,7.7,23.7    c5.1,5.5,11.6,8.3,19.4,8.3C948.7,860.2,953.4,859,957.7,856.6z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1186.3,784.9c8.1,8.1,12.2,19.5,12.2,34v63.3h-27.3v-59.6c0-8.4-2.1-14.9-6.4-19.4    c-4.3-4.5-10.1-6.7-17.5-6.7s-13.3,2.2-17.6,6.7c-4.4,4.5-6.5,10.9-6.5,19.4v59.6h-27.3v-59.6c0-8.4-2.1-14.9-6.4-19.4    c-4.3-4.5-10.1-6.7-17.5-6.7c-7.5,0-13.5,2.2-17.8,6.7c-4.4,4.5-6.5,10.9-6.5,19.4v59.6h-27.3v-108h27.3v13.1    c3.5-4.5,8-8.1,13.5-10.7c5.5-2.6,11.6-3.9,18.2-3.9c8.4,0,16,1.8,22.6,5.4c6.6,3.6,11.8,8.7,15.4,15.3c3.5-6.2,8.6-11.2,15.3-15    c6.7-3.8,13.9-5.7,21.7-5.7C1167.5,772.7,1178.2,776.8,1186.3,784.9z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1266.2,777.5c6.2-3.3,13.2-5,21.1-5c9.2,0,17.6,2.3,25,6.8c7.5,4.5,13.4,11,17.7,19.4    c4.3,8.4,6.5,18.1,6.5,29.1c0,11-2.2,20.8-6.5,29.3c-4.4,8.5-10.3,15.1-17.7,19.8c-7.5,4.7-15.8,7-25,7c-7.9,0-14.9-1.6-20.9-4.9    c-6-3.2-10.9-7.3-14.7-12.3v66.8h-27.3V774.3h27.3v15.6C1255.2,785,1260,780.8,1266.2,777.5z M1304.8,811    c-2.7-4.7-6.2-8.3-10.5-10.8c-4.4-2.5-9.1-3.7-14.1-3.7c-4.9,0-9.6,1.3-13.9,3.8c-4.4,2.5-7.9,6.2-10.5,11c-2.7,4.8-4,10.5-4,17    c0,6.5,1.3,12.2,4,17c2.7,4.8,6.2,8.5,10.5,11c4.3,2.5,9,3.8,13.9,3.8c5.1,0,9.8-1.3,14.1-3.9c4.3-2.6,7.9-6.3,10.5-11.1    c2.7-4.8,4-10.5,4-17.1C1308.8,821.4,1307.4,815.8,1304.8,811z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1383.8,738.1v144.2h-27.3V738.1H1383.8z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1510.2,836.5h-78.9c0.6,7.8,3.4,13.9,8.2,18.3c4.8,4.4,10.7,6.6,17.7,6.6    c10.1,0,17.3-4.4,21.6-13.1h29.4c-3.1,10.4-9.1,18.9-17.9,25.6c-8.8,6.7-19.7,10-32.5,10c-10.4,0-19.7-2.3-28-6.9    c-8.3-4.6-14.7-11.1-19.3-19.6c-4.6-8.4-6.9-18.2-6.9-29.2c0-11.2,2.3-21,6.8-29.4c4.5-8.4,10.9-14.9,19.1-19.5    c8.2-4.5,17.6-6.8,28.3-6.8c10.3,0,19.5,2.2,27.6,6.6c8.1,4.4,14.4,10.7,18.9,18.8c4.5,8.1,6.7,17.4,6.7,28    C1511,829.8,1510.8,833.3,1510.2,836.5z M1482.8,818.1c-0.1-7-2.7-12.6-7.6-16.9c-4.9-4.2-11-6.3-18.1-6.3c-6.8,0-12.4,2-17.1,6.1    c-4.6,4.1-7.4,9.8-8.5,17.1H1482.8z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1562.7,796.7v52.2c0,3.6,0.9,6.3,2.6,7.9c1.8,1.6,4.7,2.4,8.9,2.4h12.7v23h-17.1    c-23,0-34.5-11.2-34.5-33.5v-52h-12.9v-22.4h12.9v-26.7h27.5v26.7h24.2v22.4H1562.7z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1608.4,756.9c-3.2-3.1-4.8-6.9-4.8-11.4c0-4.5,1.6-8.3,4.8-11.4c3.2-3.1,7.2-4.6,12-4.6    c4.8,0,8.8,1.5,12,4.6c3.2,3.1,4.8,6.9,4.8,11.4c0,4.5-1.6,8.3-4.8,11.4c-3.2,3.1-7.2,4.6-12,4.6    C1615.5,761.4,1611.5,759.9,1608.4,756.9z M1633.8,774.3v108h-27.3v-108H1633.8z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1680.6,877.1c-8.3-4.6-14.8-11.1-19.6-19.6c-4.7-8.4-7.1-18.2-7.1-29.2c0-11,2.4-20.8,7.3-29.2    c4.9-8.4,11.5-15,20-19.6c8.4-4.6,17.9-6.9,28.3-6.9c10.4,0,19.8,2.3,28.3,6.9c8.4,4.6,15.1,11.1,20,19.6    c4.9,8.4,7.3,18.2,7.3,29.2c0,11-2.5,20.8-7.5,29.2c-5,8.4-11.8,15-20.3,19.6c-8.5,4.6-18,6.9-28.5,6.9    C1698.2,884,1688.9,881.7,1680.6,877.1z M1722.5,856.6c4.3-2.4,7.8-6,10.4-10.8c2.6-4.8,3.9-10.7,3.9-17.5    c0-10.3-2.7-18.2-8.1-23.7c-5.4-5.5-12-8.3-19.8-8.3c-7.8,0-14.3,2.8-19.6,8.3c-5.3,5.5-7.9,13.4-7.9,23.7    c0,10.3,2.6,18.2,7.7,23.7c5.1,5.5,11.6,8.3,19.4,8.3C1713.5,860.2,1718.2,859,1722.5,856.6z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1876,784.9c7.9,8.1,11.9,19.5,11.9,34v63.3h-27.3v-59.6c0-8.6-2.1-15.2-6.4-19.8    c-4.3-4.6-10.1-6.9-17.5-6.9c-7.5,0-13.5,2.3-17.8,6.9c-4.4,4.6-6.5,11.2-6.5,19.8v59.6H1785v-108h27.3v13.4    c3.6-4.7,8.3-8.3,13.9-11c5.7-2.7,11.9-4,18.6-4C1857.7,772.7,1868.1,776.8,1876,784.9z"
          />
        </g>
        <g>
          <rect
            x={494.2}
            y={384.3}
            style={{
              fill: '#241F20',
            }}
            width={1427.8}
            height={2.1}
          />
        </g>
        <polygon
          style={{
            opacity: 0.35,
            fill: '#FFFFFF',
          }}
          points="1875.7,1254.9 1844,1300.3 1809.1,1229.7 1847.4,1307.2 1879.1,1261.7    1934.5,1264.1 1931.1,1257.3  "
        />
        <path
          style={{
            opacity: 0.4,
            fill: '#241F20',
          }}
          d="M1875.7,1254.9l55.4,2.4l-35.9-72.5c-20.7,25.4-51.4,42.3-86.1,44.9l34.9,70.6   L1875.7,1254.9z"
        />
        <polygon
          style={{
            opacity: 0.35,
            fill: '#FFFFFF',
          }}
          points="1723.8,1254.9 1668.5,1257.3 1665.1,1264.1 1720.4,1261.7 1752.2,1307.2    1790.4,1229.7 1755.5,1300.3  "
        />
        <path
          style={{
            opacity: 0.4,
            fill: '#241F20',
          }}
          d="M1704.3,1184.8l-35.9,72.5l55.4-2.4l31.7,45.4l34.9-70.6   C1755.8,1227.1,1725.1,1210.2,1704.3,1184.8z"
        />
        <path
          style={{
            opacity: 0.2,
            fill: '#FFFFFF',
          }}
          d="M1895.2,1184.8c17.3-21.2,27.7-48.3,27.7-77.9c0-68-55.2-123.2-123.2-123.2   c-68,0-123.2,55.2-123.2,123.2c0,29.5,10.4,56.6,27.7,77.9c20.7,25.4,51.4,42.3,86.1,44.9c3.1,0.2,6.2,0.4,9.3,0.4   c3.1,0,6.2-0.2,9.3-0.4C1843.8,1227.1,1874.5,1210.2,1895.2,1184.8z M1799.8,1197.2c-49.8,0-90.3-40.5-90.3-90.3   c0-49.8,40.5-90.3,90.3-90.3c49.8,0,90.3,40.5,90.3,90.3C1890.1,1156.7,1849.6,1197.2,1799.8,1197.2z"
        />
        <path
          style={{
            opacity: 0.3,
            fill: '#241F20',
          }}
          d="M1799.8,1025.2c-45,0-81.7,36.6-81.7,81.7c0,45,36.6,81.7,81.7,81.7   c45,0,81.7-36.6,81.7-81.7C1881.5,1061.9,1844.8,1025.2,1799.8,1025.2z M1785.2,1152c-0.2-0.5-0.4-0.9-0.6-1.3   c-1.1-2.3-2.2-4.6-3.4-6.8c-1.3-2.3-2.7-4.6-4.1-6.8c-1.2-1.9-2.4-3.7-3.7-5.4c-0.9-1.3-1.9-2.5-2.9-3.7c-0.9-1.2-1.9-2.3-2.9-3.4   c-1.9-2.1-3.8-4.1-5.8-6.1c-1.9-1.8-3.9-3.4-5.8-5.1c-1.8-1.5-3.7-2.9-5.6-4.1c-0.7-0.4-1.3-0.9-1.9-1.3c-0.3-0.2-0.2-0.3,0-0.4   c1-0.5,2-0.9,3.1-1.1c0.2,0,0.5-0.1,0.7-0.1c0.7-0.1,1.5-0.2,2.2-0.3c0.5,0,0.9-0.1,1.4-0.1c0.7,0,1.4,0,2,0c0.4,0,0.8,0.1,1.1,0.1   c0.1,0,0.1,0,0.2,0c0.3,0.1,0.6,0.1,0.9,0.2c1,0,1.9,0.4,2.9,0.7c0.7,0.3,1.5,0.4,2.1,0.8c1.4,0.7,2.8,1.3,4.2,2.1   c2,1.3,3.9,2.6,5.8,4.1c1.2,0.9,2.3,2,3.4,3c0.9,0.8,1.7,1.5,2.6,2.4c1.2,1.1,2.3,2.3,3.4,3.5c0.2,0.3,0.4,0.3,0.6,0   c1.1-1.8,2.2-3.5,3.4-5.3c1.4-2.1,2.8-4.2,4.3-6.4c1-1.5,2.1-3,3.1-4.5c1.3-1.8,2.6-3.6,3.9-5.4c1.2-1.6,2.4-3.2,3.6-4.8   c0.9-1.2,1.9-2.3,2.8-3.5c1.2-1.4,2.3-2.8,3.5-4.2c1-1.1,2-2.3,3-3.4c1.9-2,3.8-4,5.7-5.9c1.6-1.6,3.3-3,5-4.5   c1.6-1.3,3.2-2.6,4.9-3.9c1.6-1.1,3.2-2.2,4.8-3.2c0.9-0.6,2-1,3-1.5c1.1-0.5,2.2-0.8,3.2-1.2c1.9-0.8,3.9-0.7,6-0.7   c0.5,0,0.9,0.2,1.4,0.3C1821.8,1090.7,1800.9,1119.5,1785.2,1152z"
        />
        <path
          style={{
            opacity: 0.5,
            fill: '#FFFFFF',
          }}
          d="M1839.4,1065.2c-1.1,0.4-2.2,0.8-3.2,1.2c-1,0.4-2,0.9-3,1.5c-1.7,1-3.3,2.1-4.8,3.2   c-1.7,1.2-3.3,2.5-4.9,3.9c-1.7,1.5-3.4,2.9-5,4.5c-2,1.9-3.8,3.9-5.7,5.9c-1,1.1-2.1,2.2-3,3.4c-1.2,1.4-2.3,2.8-3.5,4.2   c-1,1.2-1.9,2.3-2.8,3.5c-1.2,1.6-2.4,3.2-3.6,4.8c-1.3,1.8-2.6,3.6-3.9,5.4c-1.1,1.5-2.1,3-3.1,4.5c-1.4,2.1-2.9,4.2-4.3,6.4   c-1.1,1.8-2.3,3.5-3.4,5.3c-0.2,0.4-0.3,0.3-0.6,0c-1.1-1.2-2.3-2.4-3.4-3.5c-0.8-0.8-1.7-1.6-2.6-2.4c-1.1-1-2.2-2.1-3.4-3   c-1.9-1.4-3.8-2.8-5.8-4.1c-1.3-0.8-2.7-1.5-4.2-2.1c-0.7-0.3-1.4-0.5-2.1-0.8c-0.9-0.3-1.9-0.7-2.9-0.7c-0.3-0.1-0.6-0.1-0.9-0.2   c-0.1,0-0.1,0-0.2,0c-0.4,0-0.8-0.1-1.1-0.1c-0.7,0-1.4,0-2,0c-0.5,0-0.9,0.1-1.4,0.1c-0.7,0.1-1.5,0.2-2.2,0.3   c-0.2,0-0.5,0.1-0.7,0.1c-1.1,0.2-2.1,0.5-3.1,1.1c-0.3,0.1-0.4,0.2,0,0.4c0.7,0.4,1.3,0.9,1.9,1.3c2,1.3,3.9,2.6,5.6,4.1   c2,1.7,4,3.3,5.8,5.1c2,1.9,3.9,4,5.8,6.1c1,1.1,1.9,2.3,2.9,3.4c1,1.2,2,2.4,2.9,3.7c1.3,1.8,2.6,3.6,3.7,5.4   c1.4,2.2,2.8,4.5,4.1,6.8c1.2,2.2,2.3,4.5,3.4,6.8c0.2,0.4,0.4,0.8,0.6,1.3c15.8-32.5,36.6-61.3,61.6-87.2   c-0.4-0.1-0.9-0.2-1.4-0.3C1843.4,1064.5,1841.4,1064.4,1839.4,1065.2z"
        />
        <path
          style={{
            opacity: 0.4,
            fill: '#FFFFFF',
          }}
          d="M1799.8,1016.6c-49.8,0-90.3,40.5-90.3,90.3c0,49.8,40.5,90.3,90.3,90.3   c49.8,0,90.3-40.5,90.3-90.3C1890.1,1057.1,1849.6,1016.6,1799.8,1016.6z M1799.8,1188.6c-45,0-81.7-36.6-81.7-81.7   c0-45,36.6-81.7,81.7-81.7c45,0,81.7,36.6,81.7,81.7C1881.5,1152,1844.8,1188.6,1799.8,1188.6z"
        />
        <path
          style={{
            opacity: 0.2,
            fill: '#FFFFFF',
          }}
          d="M78.4,76.6v349.4c3.3-0.5,6.5-0.9,9.9-1.2c13-1.2,26.5-1.3,40.3,0.2   c4.8,0.5,9.5,1.3,14.1,2.2c4.6,0.9,9.1,1.9,13.4,3.1c2.2,0.6,4.4,1.2,6.5,1.9c4.3,1.3,8.5,2.8,12.6,4.4c7.7,3,15.2,6.4,22.4,10.1   c2.4,1.2,4.8,2.5,7.2,3.8c3.8,2.1,7.5,4.2,11.2,6.5c5.5,3.3,10.9,6.8,16.3,10.4c3.6,2.4,7.1,4.8,10.6,7.2c1.7,1.2,3.5,2.4,5.2,3.7   c5.2,3.7,10.4,7.4,15.6,11.1c3.4,2.5,6.9,4.9,10.3,7.4c6.9,4.9,13.8,9.7,20.8,14.2c3.5,2.3,7,4.5,10.6,6.7c1.8,1.1,3.6,2.1,5.4,3.2   c25.6,14.8,58.3,28.8,97.3,27.7V76.6H78.4z"
        />
        <path
          style={{
            opacity: 0.02,
            fill: '#241F20',
          }}
          d="M310.6,520.8c-1.8-1-3.6-2.1-5.4-3.2c-3.6-2.2-7.1-4.4-10.6-6.7   c-7-4.6-13.9-9.4-20.8-14.2c-3.4-2.4-6.9-4.9-10.3-7.4c-5.2-3.7-10.3-7.4-15.6-11.1c-1.7-1.2-3.5-2.5-5.2-3.7   c-3.5-2.4-7-4.9-10.6-7.2c-5.3-3.6-10.7-7-16.3-10.4c-3.7-2.2-7.4-4.4-11.2-6.5c-2.4-1.3-4.7-2.6-7.2-3.8   c-7.2-3.7-14.7-7.1-22.4-10.1c-4.1-1.6-8.3-3-12.6-4.4c-2.1-0.7-4.3-1.3-6.5-1.9c-4.4-1.2-8.9-2.2-13.4-3.1   c-4.6-0.9-9.3-1.6-14.1-2.2c-13.8-1.6-27.3-1.5-40.3-0.2c-3.3,0.3-6.6,0.7-9.9,1.2v135c5.7,1,11.7,2.3,17.9,3.9   c4.9,1.3,9.9,2.7,15,4.4c7.7,2.5,15.7,5.5,23.9,9.1c5.5,2.4,11.1,5,16.8,7.9c8.6,4.3,17.4,9.3,26.5,14.9c9,5.6,18.3,11.9,27.8,19   c2,1.5,4.1,3.1,6.2,4.7c2.1,1.6,4.1,3.2,6.2,4.9c7.9,6.4,15.6,12.3,23.1,17.7c2.5,1.8,5,3.6,7.4,5.3c7.4,5.2,14.5,9.9,21.5,14.3   c4.7,2.9,9.2,5.6,13.7,8.2c9,5.1,17.7,9.6,26.1,13.4c7.4,3.4,14.5,6.2,21.4,8.7c6.9,2.4,13.7,4.5,20.2,6.1c1.9,0.5,3.7,0.9,5.6,1.3   c5.5,1.2,10.9,2.1,16.2,2.8c1.8,0.2,3.5,0.4,5.2,0.6c5.2,0.5,10.3,0.8,15.2,0.8c4.6,0,9.2-0.1,13.6-0.5V548.5   C368.9,549.6,336.2,535.6,310.6,520.8z"
        />
        <path
          style={{
            opacity: 0.2,
            fill: '#241F20',
          }}
          d="M394.3,708.9c-5,0-10-0.3-15.2-0.8c-1.7-0.2-3.5-0.4-5.2-0.6   c-5.3-0.7-10.7-1.6-16.2-2.8c-1.8-0.4-3.7-0.8-5.6-1.3c-6.5-1.6-13.3-3.6-20.2-6.1c-6.9-2.4-14.1-5.3-21.4-8.7   c-8.4-3.8-17.1-8.3-26.1-13.4c-4.5-2.6-9.1-5.3-13.7-8.2c-7-4.4-14.2-9.1-21.5-14.3c-2.5-1.7-4.9-3.5-7.4-5.3   c-7.5-5.5-15.2-11.4-23.1-17.7c-2.1-1.7-4.2-3.3-6.2-4.9c-2.1-1.6-4.1-3.2-6.2-4.7c-9.4-7.1-18.7-13.4-27.8-19   c-9-5.6-17.9-10.6-26.5-14.9c-5.7-2.9-11.3-5.5-16.8-7.9c-8.3-3.6-16.2-6.5-23.9-9.1c-5.1-1.7-10.1-3.1-15-4.4   c-6.2-1.6-12.2-2.9-17.9-3.9v832.4h329.5V708.4C403.4,708.8,398.9,708.9,394.3,708.9z"
        />
      </g>
      <g id="Course_Name">
        <g>
          <rect
            x={472.9}
            y={1198.7}
            style={{
              fill: '#231F20',
            }}
            width={1134.5}
            height={2.1}
          />
        </g>
      </g>
      <g id="Learner_Name">
        <g>
          <rect
            x={472.9}
            y={1082.3}
            style={{
              fill: '#231F20',
            }}
            width={713.4}
            height={2.1}
          />
        </g>
      </g>
      <g id="Date">
        <rect
          x={1231.6}
          y={1082.3}
          style={{
            fill: '#231F20',
          }}
          width={375.8}
          height={2.1}
        />
      </g>
    </svg>
  );
};
